import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { z } from "zod";

export const filterConnectorConfigsSchema = z.object({
  protocol_contains: z.string().nullable().optional(),
  connector_contains: z.string().nullable().optional(),
  path_contains: z.string().nullable().optional(),
  method_contains: z.string().nullable().optional(),
  file_pattern_contains: z.string().nullable().optional(),
  email_source_type_contains: z.string().nullable().optional(),
  email_subject_user_contains: z.string().nullable().optional(),
});

export type FilterConnectorConfigsSchema = z.infer<
  typeof filterConnectorConfigsSchema
>;

export const fields: Field[] = [
  { name: "protocol_contains", label: "Protocol", type: "input" },
  { name: "connector_contains", label: "Connector", type: "input" },
  { name: "path_contains", label: "Path", type: "input" },
  { name: "method_contains", label: "Method", type: "input" },
  { name: "file_pattern_contains", label: "File Pattern", type: "input" },
  { name: "email_source_type_contains", label: "Email Source Type", type: "input" },
  { name: "email_subject_user_contains", label: "Email Subject User", type: "input" },
];

export const client = "qtl - etl";

export function FilterConnectorConfigs() {
  return (
    <FilterTable
      client={client}
      schema={filterConnectorConfigsSchema}
      tableName="connector_configs"
      customBuildPath={() => `${client}/connector_configs`}
      fields={fields}
      columns={2}
    />
  );
}
